module.exports = "/dist/3ddb74822e003b3b41232aa6e64d656b.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-300italic.woff2
// module id = 151
// module chunks = 0